import { serviceMaker, methods, api } from "@/http/index.js";

export const getHolidaysList = () =>
  serviceMaker(`/holidays/list`, methods.GET, api.NGB);
export const createHoliday = (data) =>
  serviceMaker(`/holidays`, methods.POST, api.NGB, data);
export const updateHoliday = (id, data) =>
  serviceMaker(`/holidays/${id}`, methods.PUT, api.NGB, data);
export const deleteHoliday = (id) =>
  serviceMaker(`/holidays/${id}`, methods.DELETE, api.NGB);
export const getHolidayById = (id) =>
  serviceMaker(`/holidays/${id}`, methods.GET, api.NGB);
export const getCalendarHolidays = (fromDate, toDate, userId) => {
  const params = new URLSearchParams();

  if (userId) params.append("userId", userId);
  if (fromDate) params.append("fromdate", fromDate);
  if (toDate) params.append("todate", toDate);

  const queryString = params.toString();
  const url = `/useravailability/user/unavailability${queryString ? `?${queryString}` : ""}`;

  return serviceMaker(url, methods.GET, api.NGB);
};